import React, { useContext, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'gatsby'
import LanguageContext from '../../../contexts/languageContext'
import PageContext from '../../../contexts/pageContext'
import LanguageSwapper from '../../LanguageSwapper'
import styles from './styles.module.css'
import { SideMenuContext } from '../../../contexts/sideMenuContext'

function SidebarFooter() {
  const { lang } = useContext(LanguageContext)
  const { setCurrentPage } = useContext(PageContext)
  const { setSubmenu } = useContext(SideMenuContext)
  const { t } = useTranslation()

  const termsOfUse = useMemo(
    () => ({
      path: `/${lang}/tos`,
      onClick: () => {
        setSubmenu(null)
        setCurrentPage('tos')
      },
    }),
    [lang, setSubmenu, setCurrentPage]
  )

  return (
    <ul>
      <LanguageSwapper />
      <li className={styles.linksContainer}>
        <ul className={styles.footerLinks}>
          <div className={styles.footerLinksLine}></div>
          <li>
            <a href={t('navLinks.support.link')} target="_blank" rel="noopener noreferrer">
              {t('navLinks.support.label')}
            </a>
          </li>
          <li>
            <Link to={termsOfUse.path} onClick={termsOfUse.onClick}>
              {t('navLinks.terms.label')}
            </Link>
          </li>
          <li>
            <a href={t('navLinks.privacy.link')} target="_blank" rel="noopener noreferrer">
              {t('navLinks.privacy.label')}
            </a>
          </li>
        </ul>
      </li>
    </ul>
  )
}

export default SidebarFooter
